const MENU_TATAR = [
  {
    name: 'geo.objects', title: 'Территориальная схема', number: '01'
  },
  {
    name: 'msn',
    childs: [
      {
        name: 'msn.withContainers'
      },
      {
        name: 'msn.withoutContainers'
      },
      {
        name: 'msn.separateCollections'
      }
    ]
  },
  {name: 'registry.operators'},
  {name: 'analytic'},
  {
    name: 'access',
    childs: [
      {name: 'access.users'},
      {name: 'access.usersGroups'}
    ]
  },
  {name: 'waybill'},
  {
    name: 'routes',
    childs: [
      {name: 'routes.routes'},
      {name: 'routes.schedule'}
    ]
  },
  {name: 'carPark'},
  {name: 'staffManagement'}
]

export default MENU_TATAR
